import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import icMoreVert from "@iconify/icons-ic/twotone-more-vert";
import icClose from "@iconify/icons-ic/twotone-close";
import icPrint from "@iconify/icons-ic/twotone-print";
import icDownload from "@iconify/icons-ic/twotone-cloud-download";
import icDelete from "@iconify/icons-ic/twotone-delete";
import icPhone from "@iconify/icons-ic/twotone-phone";
import icPerson from "@iconify/icons-ic/twotone-person";
import icMyLocation from "@iconify/icons-ic/twotone-my-location";
import icSelectAll from "@iconify/icons-ic/twotone-select-all";
import icLocationCity from "@iconify/icons-ic/twotone-location-city";
import icEditLocation from "@iconify/icons-ic/twotone-edit-location";
import { fadeInUp400ms } from "../../../../../../../../@vex/animations/fade-in-up.animation";
import { FormControl } from "@angular/forms";
import { CustomFieldService } from "../../../../../../../../@vex/services/customfieldService/customFieldService";
import { JobList } from "../interfaces/job-list.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as moment from 'moment';
import { MatChipInputEvent } from "@angular/material/chips";
import { MatAutocomplete, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { TranslateService } from "@ngx-translate/core";
import { BaseComponent } from "src/app/components/base/base.component";

@Component({
  selector: 'vex-job-list-create-update',
  templateUrl: './job-list-create-update.component.html',
  styleUrls: ['./job-list-create-update.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInUp400ms],
})
export class JobListCreateUpdateComponent extends BaseComponent implements OnInit {
  public status = true;
  public required = true;
  static id = 100;
  static order = 100;
  form: FormGroup;
  mode: "create" | "update" = "create";

  icMoreVert = icMoreVert;
  icClose = icClose;

  icPrint = icPrint;
  icDownload = icDownload;
  icDelete = icDelete;
  icSelectAll = icSelectAll;
  icPerson = icPerson;
  icMyLocation = icMyLocation;
  icLocationCity = icLocationCity;
  icEditLocation = icEditLocation;
  icPhone = icPhone;
  fruits3: string[] = [];
  text = `<p class="ql-align-center" > Thank you for your application, we will consider you for future employment.</p>`;
  letterDetail = new FormControl(this.text);
  filteredFruits3: Observable<string[]>;
  allFruits3: string[] = [];
  selectable3 = true;
  removable3 = true;
  separatorKeysCodes3: number[] = [ENTER, COMMA];

  @ViewChild('fruitInput3') fruitInput3: ElementRef<HTMLInputElement>;
  @ViewChild('auto3') matAutocomplete3: MatAutocomplete;


  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    private dialogRef: MatDialogRef<JobListCreateUpdateComponent>,
    private fb: FormBuilder,
    private _customFieldService: CustomFieldService,
    public snackBar: MatSnackBar,
    public translate: TranslateService,
  ) { 
    super(snackBar, translate);
  }

  ngOnInit() {
    if (this.defaults) {
      this.mode = "update";
      if (this.defaults.customFieldRequired === 1) {
        this.required = true
      } if (this.defaults.customFieldRequired === 0) {
        this.required = false
      } if (this.defaults.status === 1) {
        this.status = true
      } if (this.defaults.status === 0) {
        this.status = false
      }
      // fruits3
      this.defaults.selectFromValue.forEach(e => {
        this.fruits3.push(e)
      })
    } else {
      this.defaults = {} as JobList;
    }

    // console.log(this.defaults);

    this.form = this.fb.group({
      selectFromValue: [this.defaults.selectFromValue || ''],
      customFieldOrder: [this.defaults.customFieldOrder || ''],
      customFieldType: [this.defaults.customFieldType || ''],
      customFieldName: [this.defaults.customFieldName || ''],
      customFieldAbbreviation: [this.defaults.customFieldAbbreviation || ''],
      customFieldLocation: [this.defaults.customFieldLocation || ''],
      customFieldDisplayFor: [this.defaults.customFieldDisplayFor || ''],
    });


    this.filteredFruits3 = this.form.controls.selectFromValue.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter3(fruit) : this.allFruits3.slice()));
  }

  save() {
    if (this.mode === "create") {
      this.createCustomer();
    } else if (this.mode === "update") {
      this.updateCustomer();
    }
  }

  changeRequired(ob: MatSlideToggleChange) {
    this.required = ob.checked
  }

  changeStatus(ob: MatSlideToggleChange) {
    this.status = ob.checked
  }

  createCustomer() {
    const customField = this.form.value;
    var selectionFormValue = this.fruits3.join(',')
    const customFieldBody = {
      "customFieldName": customField.customFieldName,
      "customFieldAbbreviation": customField.customFieldAbbreviation,
      "customFieldOrder": +customField.customFieldOrder,
      "customFieldLocation": +customField.customFieldLocation,
      "customFieldType": +customField.customFieldType,
      "selectFromValue": selectionFormValue,
      "customFieldDisplayFor": +customField.customFieldDisplayFor,
      "customFieldRequired": +this.required,
      "status": +this.status,
      "enterdate": moment().format('YYYY/MM/DD'),
    }
    this._customFieldService.addCustomField(customFieldBody).subscribe((res) => {
      // console.log(res);
      if (res.message) {
        this.showSuccess(this.translate.instant('SNACKBAR.JOB_CUSTOM_FIELD_ADDED_SUCCESSFULLY'));
        this.dialogRef.close(customField);
      }
    }, (err) => {
      // console.log(err);
    });
  }

  updateCustomer() {
    const customField = this.form.value;
    var selectionFormValue = this.fruits3.join(',')
    if (this.required === true) {
      var required = 1
    } if (this.required === false) {
      var required = 0
    } if (this.status === true) {
      var status = 1
    } if (this.status === false) {
      var status = 0
    }

    const customFieldBody = {
      "customFieldID": this.defaults.customFieldID,
      "selectFromValue": selectionFormValue,
      "customFieldOrder": +customField.customFieldOrder,
      "customFieldLocation": +customField.customFieldLocation,
      "customFieldRequired": +required,
      "status": +status,
      "customFieldAbbreviation": customField.customFieldAbbreviation,
      "customFieldDisplayFor": +customField.customFieldDisplayFor,
      "customFieldName": customField.customFieldName,
      "customFieldType": +customField.customFieldType,
      "enterdate": moment().format('YYYY/MM/DD'),
    }
    this._customFieldService.updateCustomField(customFieldBody, this.defaults.customFieldID).subscribe((res) => {
      if (res.message) {
        this.showSuccess(this.translate.instant('SNACKBAR.JOB_CUSTOM_FIELD_UPDATED_SUCCESSFULLY'));
        this.dialogRef.close(customField);
      }
    }, (err) => {
      // console.log(err);
    });
  }

  isCreateMode() {
    return this.mode === "create";
  }

  isUpdateMode() {
    return this.mode === "update";
  }



  add3(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits3.push(value.trim());
    }

    // Reset the input value

    if (input) {
      input.value = '';
      // if (this.question_type === '11') {
      //   if (this.fruits3) {
      //     this.knockOutData = [];
      //     this.fruits3.map(data => {
      //       const selectLists = { item: data, value: data }
      //       this.knockOutList_11.push(selectLists);
      //     })
      //     this.knockOutData = _.uniqBy(this.knockOutList_11, 'item');;
      //   }
      // }
    }

    this.form.controls.selectFromValue.setValue(null);
  }

  remove3(fruit: string): void {
    const index = this.fruits3.indexOf(fruit);

    if (index >= 0) {
      this.fruits3.splice(index, 1);
    }
  }

  selected3(event: MatAutocompleteSelectedEvent): void {
    this.fruits3.push(event.option.viewValue);
    this.fruitInput3.nativeElement.value = '';
    this.form.controls.selectFromValue.setValue(null);
  }

  private _filter3(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits3.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }
}
